export const casinosData = [
  {
    id: 1,
    name: "Fugu",
    bonus: "500%",
    realValue: "125 000 ₽",
    difficulty: "Средне",
    wager: "x40",
    minDeposit: "500 ₽",
    maxBonus: "250 000 ₽",
    games: "Слоты, Live",
    url: "https://fugu-way-one.com/c763d5df9",
    rating: 9.8,
    logo: "https://public.readdy.ai/ai/img_res/5ad55dda561ca595fc71e894efb9115f.jpg"
  },
  {
    id: 2,
    name: "SOL",
    bonus: "200% + 50 FS",
    realValue: "85 000 ₽",
    difficulty: "Легко",
    wager: "x35",
    minDeposit: "1000 ₽",
    maxBonus: "170 000 ₽",
    games: "Все игры",
    url: "https://sol-blsm10.com/c26114c36",
    rating: 9.7,
    logo: "https://readdy.ai/api/search-image?query=bright%20sun%20casino%20logo%20with%20SOL%20letters%20on%20vibrant%20orange%20background%2C%20modern%20gambling%20brand%2C%20clean%20vector%20design%2C%20energetic%20style%2C%20professional%20identity&width=200&height=200&seq=sol2&orientation=squarish"
  },
  {
    id: 3,
    name: "FRESH",
    bonus: "150% + 100 FS",
    realValue: "95 000 ₽",
    difficulty: "Легко",
    wager: "x30",
    minDeposit: "500 ₽",
    maxBonus: "150 000 ₽",
    games: "Слоты",
    url: "https://fresh-blrs10.com/cf443d7fa",
    rating: 9.6,
    logo: "https://readdy.ai/api/search-image?query=fresh%20green%20casino%20logo%20with%20modern%20typography%20on%20clean%20white%20background%2C%20minimalist%20gambling%20brand%2C%20professional%20vector%20style%2C%20crisp%20design&width=200&height=200&seq=fresh3&orientation=squarish"
  },
  {
    id: 4,
    name: "LEX",
    bonus: "100% + 200 FS",
    realValue: "78 000 ₽",
    difficulty: "Легко",
    wager: "x35",
    minDeposit: "1000 ₽",
    maxBonus: "100 000 ₽",
    games: "Слоты, Live",
    url: "https://lexyway1.com/c737609d2",
    rating: 9.5,
    logo: "https://readdy.ai/api/search-image?query=elegant%20LEX%20casino%20logo%20with%20royal%20crown%20on%20deep%20purple%20background%2C%20luxury%20gambling%20brand%20identity%2C%20sophisticated%20vector%20design%2C%20premium%20style&width=200&height=200&seq=lex4&orientation=squarish"
  },
  {
    id: 5,
    name: "MONRO",
    bonus: "120% + 30 FS",
    realValue: "72 000 ₽",
    difficulty: "Средне",
    wager: "x40",
    minDeposit: "500 ₽",
    maxBonus: "120 000 ₽",
    games: "Все игры",
    url: "https://mnr-blse21.com/c831ca2e4",
    rating: 9.4,
    logo: "https://readdy.ai/api/search-image?query=classic%20MONRO%20casino%20logo%20with%20diamond%20symbol%20on%20black%20background%2C%20timeless%20gambling%20brand%2C%20elegant%20vector%20design%2C%20luxury%20identity&width=200&height=200&seq=monro5&orientation=squarish"
  },
  {
    id: 6,
    name: "IZZI",
    bonus: "150%",
    realValue: "88 000 ₽",
    difficulty: "Легко",
    wager: "x30",
    minDeposit: "1000 ₽",
    maxBonus: "150 000 ₽",
    games: "Слоты, Live",
    url: "https://izzi-blrs10.com/c4a329f8e",
    rating: 9.3,
    logo: "https://readdy.ai/api/search-image?query=playful%20IZZI%20casino%20logo%20with%20colorful%20design%20on%20bright%20background%2C%20fun%20gambling%20brand%20identity%2C%20modern%20vector%20style%2C%20energetic%20look&width=200&height=200&seq=izzi6&orientation=squarish"
  },
  {
    id: 7,
    name: "STARDA",
    bonus: "100% + 50 FS",
    realValue: "65 000 ₽",
    difficulty: "Средне",
    wager: "x40",
    minDeposit: "500 ₽",
    maxBonus: "100 000 ₽",
    games: "Слоты",
    url: "https://strd-blit10.com/c3369b683",
    rating: 9.2,
    logo: "https://readdy.ai/api/search-image?query=star%20STARDA%20casino%20logo%20with%20golden%20stars%20on%20dark%20blue%20background%2C%20celestial%20gambling%20brand%2C%20professional%20vector%20design%2C%20premium%20identity&width=200&height=200&seq=starda7&orientation=squarish"
  },
  {
    id: 8,
    name: "1GO",
    bonus: "200% на 1-3 деп",
    realValue: "110 000 ₽",
    difficulty: "Средне",
    wager: "x35",
    minDeposit: "1000 ₽",
    maxBonus: "200 000 ₽",
    games: "Все игры",
    url: "https://1go-blrs10.com/c8100c010",
    rating: 9.1,
    logo: "https://readdy.ai/api/search-image?query=dynamic%201GO%20casino%20logo%20with%20racing%20theme%20on%20red%20background%2C%20speed%20gambling%20brand%20identity%2C%20bold%20vector%20design%2C%20modern%20style&width=200&height=200&seq=1go8&orientation=squarish"
  },
  {
    id: 9,
    name: "LEGZO",
    bonus: "100% + 50 FS",
    realValue: "68 000 ₽",
    difficulty: "Легко",
    wager: "x35",
    minDeposit: "500 ₽",
    maxBonus: "100 000 ₽",
    games: "Слоты, Live",
    url: "https://gzo-blrs21.com/cb153ccec",
    rating: 9.0,
    logo: "https://readdy.ai/api/search-image?query=modern%20LEGZO%20casino%20logo%20with%20geometric%20shapes%20on%20teal%20background%2C%20contemporary%20gambling%20brand%2C%20clean%20vector%20design%2C%20professional%20identity&width=200&height=200&seq=legzo9&orientation=squarish"
  },
  {
    id: 10,
    name: "ROX",
    bonus: "150%",
    realValue: "82 000 ₽",
    difficulty: "Средне",
    wager: "x40",
    minDeposit: "1000 ₽",
    maxBonus: "150 000 ₽",
    games: "Все игры",
    url: "https://rox-media4.com/c72ce8213",
    rating: 8.9,
    logo: "https://readdy.ai/api/search-image?query=powerful%20ROX%20casino%20logo%20with%20rock%20theme%20on%20grey%20background%2C%20strong%20gambling%20brand%20identity%2C%20bold%20vector%20design%2C%20masculine%20style&width=200&height=200&seq=rox10&orientation=squarish"
  },
  {
    id: 11,
    name: "VOLNA",
    bonus: "110% + 20 FS",
    realValue: "62 000 ₽",
    difficulty: "Легко",
    wager: "x30",
    minDeposit: "500 ₽",
    maxBonus: "110 000 ₽",
    games: "Слоты",
    url: "https://vln-blrs.com/c6fd2926e",
    rating: 8.8,
    logo: "https://readdy.ai/api/search-image?query=wave%20VOLNA%20casino%20logo%20with%20ocean%20theme%20on%20blue%20background%2C%20aquatic%20gambling%20brand%2C%20flowing%20vector%20design%2C%20elegant%20identity&width=200&height=200&seq=volna11&orientation=squarish"
  },
  {
    id: 12,
    name: "DRIP",
    bonus: "300% + 20 FS",
    realValue: "115 000 ₽",
    difficulty: "Сложно",
    wager: "x45",
    minDeposit: "1000 ₽",
    maxBonus: "300 000 ₽",
    games: "Слоты, Live",
    url: "https://drp-blrs21.com/c4cea69e8",
    rating: 8.7,
    logo: "https://readdy.ai/api/search-image?query=liquid%20DRIP%20casino%20logo%20with%20water%20drops%20on%20cyan%20background%2C%20fluid%20gambling%20brand%20identity%2C%20modern%20vector%20design%2C%20dynamic%20style&width=200&height=200&seq=drip12&orientation=squarish"
  },
  {
    id: 13,
    name: "GIZBO",
    bonus: "100% + 100 FS",
    realValue: "75 000 ₽",
    difficulty: "Легко",
    wager: "x35",
    minDeposit: "500 ₽",
    maxBonus: "100 000 ₽",
    games: "Все игры",
    url: "https://gizbo-way-seven.com/ce6052c2f",
    rating: 8.6,
    logo: "https://readdy.ai/api/search-image?query=tech%20GIZBO%20casino%20logo%20with%20digital%20elements%20on%20neon%20background%2C%20futuristic%20gambling%20brand%2C%20modern%20vector%20design%2C%20innovative%20identity&width=200&height=200&seq=gizbo13&orientation=squarish"
  },
  {
    id: 14,
    name: "IRWIN",
    bonus: "200%",
    realValue: "98 000 ₽",
    difficulty: "Средне",
    wager: "x40",
    minDeposit: "1000 ₽",
    maxBonus: "200 000 ₽",
    games: "Слоты, Live",
    url: "https://irwin-way-one.com/c372c38e2",
    rating: 8.5,
    logo: "https://readdy.ai/api/search-image?query=classic%20IRWIN%20casino%20logo%20with%20vintage%20style%20on%20burgundy%20background%2C%20traditional%20gambling%20brand%20identity%2C%20elegant%20vector%20design%2C%20timeless%20look&width=200&height=200&seq=irwin14&orientation=squarish"
  },
  {
    id: 15,
    name: "Flagman",
    bonus: "100% + 25 FS",
    realValue: "58 000 ₽",
    difficulty: "Легко",
    wager: "x35",
    minDeposit: "500 ₽",
    maxBonus: "100 000 ₽",
    games: "Слоты",
    url: "https://flagmanway1.com/cc2db1682",
    rating: 8.4,
    logo: "https://readdy.ai/api/search-image?query=flagship%20FLAGMAN%20casino%20logo%20with%20nautical%20theme%20on%20navy%20background%2C%20maritime%20gambling%20brand%2C%20professional%20vector%20design%2C%20authoritative%20identity&width=200&height=200&seq=flagman15&orientation=squarish"
  }
];